import React from "react";
import { useActor } from "@xstate/react";
import SingleSelect from "../SingleSelect";
import { ALL_GYM_SUBTYPES, OTHER } from "../../../../constants/gymSubtypes";
import { useSignUpMachine } from "../../context/SignUpMachineContext";
import { SignUpFormField } from "../../constants/signup-form-field.enum";
import { BalancedStepTitle } from "../BalancedStepTitle";

const VerticalStep: React.FC = () => {
  const machine = useSignUpMachine();
  const [state, send] = useActor(machine);
  const { formData } = state.context;

  const verticalValue = formData[SignUpFormField.Vertical];
  const typeaheadPlaceholder = "Search for your gym type";

  const handleChange = (value: any) => {
    send({
      type: "UPDATE_FORM",
      data: { [SignUpFormField.Vertical]: value },
    });
  };

  const field = {
    id: SignUpFormField.Vertical,
    required: true,
    options: [
      { id: "input-vertical-crossfit", label: "CrossFit", value: "CrossFit" },
      {
        id: "input-vertical-weightlifting",
        label: "Powerlifting",
        value: "Powerlifting",
      },
      {
        id: "input-vertical-bjj",
        label: "Brazilian Jiu-Jitsu",
        value: "Brazilian Jiu-Jitsu",
      },
      {
        id: "input-vertical-indoor-bootcamp",
        label: "Indoor Bootcamp",
        value: "Indoor Bootcamp",
      },
      {
        id: "input-vertical-other",
        label: "Browse More Options",
        value: "browse-more-options",
        enableSearchDropdown: true,
      },
    ],
    extraOptions: ALL_GYM_SUBTYPES.map((subtype) => {
      if (!OTHER.includes(subtype as any)) {
        return {
          id: `input-vertical-generated-${subtype}`,
          label: subtype,
          value: subtype,
        };
      }
      return undefined;
    }).filter((option) => option !== undefined),
  };

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-center">
        <BalancedStepTitle title="What is your gym's focus?" />
      </div>
      <div className="tw-space-y-4">
        <SingleSelect
          options={field.options}
          extraOptions={field.extraOptions}
          onChange={handleChange}
          value={verticalValue}
          typeaheadPlaceholder={typeaheadPlaceholder}
          progressOnSelect={() => send({ type: "NEXT" })}
        />
      </div>
    </>
  );
};

export default VerticalStep;
